import { render, staticRenderFns } from "./P010.vue?vue&type=template&id=f8745eb0"
import script from "./P010.vue?vue&type=script&lang=js"
export * from "./P010.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports